<template>
  <div>
    <ValueComparison
      :value="selectReportValueAsPercent(widgetId)"
      :comparison="selectComparisonPercent(widgetId)"
      v-if="!loading"
    />
    <ValueComparisonLoader v-else />
  </div>
</template>

<script>
import ValueComparison from '@/components/Modules/Dashboard/Widget/ReportTypes/ValueComparison'
import ValueComparisonLoader from '@/components/Modules/Dashboard/Widget/SkeletonLoaders/ValueComparisonLoader'
import { createNamespacedHelpers } from 'vuex'

const DashboardModule = createNamespacedHelpers('dashboard')

export default {
  name: 'SurveyTakeRate',
  props: ['widgetId'],
  components: {
    ValueComparison,
    ValueComparisonLoader
  },
  data: () => ({
    loading: true
  }),
  computed: {
    ...DashboardModule.mapGetters(['selectComparisonPercent', 'selectReportValueAsPercent'])
  },
  methods: {
    ...DashboardModule.mapActions(['fetchSurveyTakeRate'])
  },
  async mounted() {
    await this.fetchSurveyTakeRate({ widgetId: this.widgetId })
    this.loading = false
  }
}
</script>
